import emptyState from '../../assets/empty-state.svg';
import { Button } from '@nexelem/components';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons';

type NoRowsOrResultsOverlayStateProps = {
  onResetFilters?: () => void;
};

export const NoRowsOrResultsOverlayState = ({ onResetFilters }: NoRowsOrResultsOverlayStateProps) => {
  const { t } = useTranslation();

  return (
    <div className="box-border flex h-full flex-col items-center justify-center gap-4 py-8">
      <div
        className="h-full w-full bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${emptyState})` }}
      />
      <div className="py-4">
        <span className="text-s18 text-text-secondary">{t('components.table.emptyState.title')}</span>
      </div>
      {onResetFilters && (
        <div className="flex items-center justify-center gap-4">
          <Button StartIcon={<FontAwesomeIcon icon={faRotateLeft} />} variant="outlined" onClick={onResetFilters}>
            {t('components.table.emptyState.resetButton')}
          </Button>
        </div>
      )}
    </div>
  );
};
